// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","sublink":"Navigation_sublink__ep6TC","active":"Navigation_active__e8Bvf"};